"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Aug 20 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var SettingsOverviewDTO_1 = require("../../model/dto/SettingsOverviewDTO");

var SettingsChildrenStatsConverter_1 = require("./SettingsChildrenStatsConverter");

var SettingsOverviewDTOConverter_1 = require("./SettingsOverviewDTOConverter");

var SettingsZonesOverviewDTOConverter_1 = require("./SettingsZonesOverviewDTOConverter");
/**
 * Default implementation of {@link SettingsOverviewDTOConverter}.
 *
 * @author RV
 */


var SettingsOverviewDTOConverterImpl =
/*#__PURE__*/
function (_SettingsOverviewDTOC) {
  _inherits(SettingsOverviewDTOConverterImpl, _SettingsOverviewDTOC);

  function SettingsOverviewDTOConverterImpl(settingsZonesOverviewDTOConverter, settingsChildrenStatsConverter) {
    var _this;

    _classCallCheck(this, SettingsOverviewDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsOverviewDTOConverterImpl).call(this));
    _this.settingsZonesOverviewDTOConverter = settingsZonesOverviewDTOConverter;
    _this.settingsChildrenStatsConverter = settingsChildrenStatsConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SettingsOverviewDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SettingsOverviewDTO_1.SettingsOverviewDTO(source.productCategoryId, conversions.asObjectList(source, 'settingsZonesOverviewDTO', function (zonesDoc) {
        return _this2.settingsZonesOverviewDTOConverter.toObject(zonesDoc, conversions);
      }), source.includedInRelease, source.inPathToIncluded, conversions.asObjectOpt(source, 'childrenStats', function (doc) {
        return _this2.settingsChildrenStatsConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, {
        productCategoryId: source.productCategoryId
      });
      Object.assign(result, {
        settingsZonesOverviewDTO: conversions.asObjectArray(source, 'settingsZonesOverviewDTO', function (settingsZonesOverviewDTO) {
          return _this3.settingsZonesOverviewDTOConverter.toDocument(settingsZonesOverviewDTO, conversions);
        })
      });
      Object.assign(result, {
        includedInRelease: source.includedInRelease
      });
      Object.assign(result, {
        inPathToIncluded: source.inPathToIncluded
      });
      Object.assign(result, {
        childrenStats: source.childrenStats !== null ? this.settingsChildrenStatsConverter.toDocument(source.childrenStats, conversions) : null
      });
      return result;
    }
  }]);

  return SettingsOverviewDTOConverterImpl;
}(SettingsOverviewDTOConverter_1.SettingsOverviewDTOConverter);

SettingsOverviewDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SettingsZonesOverviewDTOConverter_1.SettingsZonesOverviewDTOConverter, SettingsChildrenStatsConverter_1.SettingsChildrenStatsConverter])], SettingsOverviewDTOConverterImpl);
exports.SettingsOverviewDTOConverterImpl = SettingsOverviewDTOConverterImpl;